import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import createSessionStoragePlugin from './plugin/vuex-session-storage'

export default new Vuex.Store({
  state: {
    token: "",
    requestCancels: [], // 当前路由的所有Axios请求取消函数
  },
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
  plugins: [createSessionStoragePlugin()]
});
